/**
 * Used for SharingLinkTemplates to match the enum in the server side code
 */

export const enum SharingAudienceTemplates {
  anyone = 0,
  organization = 1,
  specificPeople = 2,
}
